import { render, staticRenderFns } from "./TriplePlayLotteryBoard.vue?vue&type=template&id=d4d4c9d4&scoped=true&"
import script from "./TriplePlayLotteryBoard.vue?vue&type=script&lang=js&"
export * from "./TriplePlayLotteryBoard.vue?vue&type=script&lang=js&"
import style0 from "./TriplePlayLotteryBoard.vue?vue&type=style&index=0&id=d4d4c9d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d4c9d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VFlex,VImg,VRow})
